import React from "react";

export function WovoLogo({ size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 48 48"
    >
      <path
        fill="#21BEE5"
        d="M13.334 14.209a6.004 6.004 0 00-9.837 6.887l11.35 16.208a6.004 6.004 0 109.836-6.888L13.334 14.21z"
      />
      <path
        fill="#2196F3"
        d="M31.31 13.528a6.004 6.004 0 00-9.836 6.888l8.848 12.637a1.092 1.092 0 001.52.268c4.94-3.458 6.14-10.265 2.681-15.204l-3.213-4.589zM44.893 12.11a4.95 4.95 0 00-8.109 5.678l2.645 3.778a.9.9 0 001.253.22l3.087-2.16a5.23 5.23 0 001.285-7.285l-.161-.23z"
      />
    </svg>
  );
}
